import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WebcamModule } from 'ngx-webcam';
import { DndDirective } from 'src/app/global/directives/drag-and-drop/drag-and-drop.directive';
import { UploadModalComponent } from './upload-modal.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            defaultLanguage: 'fr',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [],
            },
        }),
        MatDialogModule,
        WebcamModule,
    ],
    declarations: [UploadModalComponent, DndDirective],
    exports: [UploadModalComponent],
})
export class UploadModalModule {}
